<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <h3 class="m-0">Gerenciamento de cirurgias</h3>
      </b-card-header>

      <b-card-body>
        <b-table
          :items="cirurgias"
          :fields="fields"
          :busy="loading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          no-local-sorting
          show-empty
          responsive
        >
          <template #empty>
            <div class="text-center">Nenhum registro encontrado.</div>
          </template>

          <template v-slot:cell(local_inicio)="data">
            <a
              :href="
                googleMapsLink(
                  data.item.latitude_inicio,
                  data.item.longitude_inicio
                )
              "
              target="_blank"
              class="btn btn-icon btn-link"
            >
              <img
                src="/media/mapa.png"
                alt="Google Maps"
                style="height: 30px"
              />
            </a>
          </template>

          <template v-slot:cell(local_fim)="data">
            <a
              :href="
                googleMapsLink(data.item.latitude_fim, data.item.longitude_fim)
              "
              target="_blank"
              class="btn btn-icon btn-link"
            >
              <img
                src="/media/mapa.png"
                alt="Google Maps"
                style="height: 30px"
              />
            </a>
          </template>

          <template v-slot:cell(acao)="data">
            <b-dropdown
              variant="clean"
              size="small"
              toggle-class="btn-icon"
              no-caret
            >
              <template #button-content>
                <i class="fas fa-ellipsis-h"></i>
              </template>

              <b-dropdown-item @click="imprimir(data.item.id)"
                >Imprimir</b-dropdown-item
              >
            </b-dropdown>
          </template>
        </b-table>
      </b-card-body>

      <b-card-footer>
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="m-0"
          ></b-pagination>

          <div class="d-flex align-items-center flex-wrap">
            <b-select v-model="perPage" size="sm" class="mr-4">
              <option
                v-for="option in [20, 50, 100]"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </b-select>

            <span>
              Exibindo de {{ fromPage }} até {{ toPage }} de
              {{ totalRows }} registros.
            </span>
          </div>
        </div>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CirurgiaService from "@/core/services/cirurgia.service";
import moment from "@/core/plugins/moment";

export default {
  name: "cirurgia-listar",
  data() {
    return {
      cirurgias: [],
      loading: false,
      fields: [
        {
          key: "data_cirurgia",
          label: "Data",
          formatter: "dataFormatter",
          class: "text-center align-middle",
          sortable: true,
        },
        {
          key: "nome_cirurgiao",
          label: "Cirurgião",
          sortable: true,
          class: "align-middle",
        },
        {
          key: "cirurgia_realizada",
          label: "Cirurgia",
          class: "align-middle",
          sortable: true,
        },
        {
          key: "usuario.nome",
          label: "Anestesista",
          class: "align-middle",
        },
        {
          key: "anestesia",
          label: "Anestesia",
          class: "align-middle",
        },
        {
          key: "data_cadastro",
          label: "Data de Cadastro",
          formatter: "dataHoraFormatter",
          class: "text-center align-middle",
          sortable: true,
        },
        { key: "acao", label: "Ação", class: "text-center align-middle" },
      ],
      totalRows: 0,
      toPage: 0,
      fromPage: 0,
      currentPage: 1,
      perPage: 20,
      sortBy: "data_cadastro",
      sortDesc: false,
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Cirurgias",
      },
    ]);

    this.getCirurgias();
  },

  methods: {
    getCirurgias() {
      this.loading = true;

      CirurgiaService.getCirurgias({
        page: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      })
        .then(({ data }) => {
          this.cirurgias = data.data;
          this.totalRows = data.total;
          this.toPage = data.to;
          this.fromPage = data.from;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    dataFormatter(value) {
      return value ? moment(value).format("DD/MM/YYYY") : "";
    },

    dataHoraFormatter(value) {
      return value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "";
    },

    async imprimir(cirurgiaId) {
      this.showOverlay();

      await CirurgiaService.imprimirCirurgia(cirurgiaId)
        .then((response) => {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .finally(() => {
          this.hideOverlay();
        });
    },

    showOverlay() {
      this.$store.dispatch("toggleOverlay", {
        value: true,
        message: "Processando, aguarde...",
      });
    },

    hideOverlay() {
      this.$store.dispatch("toggleOverlay", { value: false });
    },
  },

  watch: {
    currentPage() {
      this.getCirurgias();
    },

    perPage() {
      this.getCirurgias();
    },

    sortBy() {
      this.getCirurgias();
    },

    sortDesc() {
      this.getCirurgias();
    },
  },
};
</script>

<style scoped>
.custom-select-sm {
  height: calc(1.244em + 1.1rem + 2px) !important;
  width: 70px !important;
}
</style>
